<template>
  <v-app>
    <v-toolbar v-if="env === 'dev'" color="blue darken-3" dark fixed clipped-left app>
      <v-toolbar-side-icon @click.stop="showPanelsDrawer = !showPanelsDrawer"></v-toolbar-side-icon>
      <span class="title">{{ $route.name }}</span>
    </v-toolbar>

    <v-navigation-drawer v-if="env === 'dev'" fixed clipped left v-model="showPanelsDrawer" app width="220" class="grey lighten-3">
      <v-list dense class="pt-0">
        <v-list-tile v-for="item in pages" :key="item.title" :to="{path: item.page}" @click="">
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-content fluid>
      <router-view></router-view>
      <app-footer />
    </v-content>
  </v-app>
</template>

<script>
  import { mapGetters } from 'vuex'

  import CssHolder from './mixins/CssHolder'
  import Attribution from './mixins/Attribution'
  import Footer from './pages/Footer'

  export default {
    mixins: [CssHolder, Attribution],
    components: {
      'app-footer': Footer
    },
    data: () => ({
      showPanelsDrawer: false,

      pages: [
        { title: 'Dev', icon: 'dashboard', page: '/dev' },
        { title: 'OrganicStore', icon: 'dashboard', page: '/organic-store' },
        { title: 'Landing', icon: 'question_answer', page: '/landing' },
        { title: 'Store', icon: 'dashboard', page: '/store' },
        { title: 'Terms Of Services', icon: 'question_answer', page: '/tos' },
        { title: 'Privacy Policy', icon: 'question_answer', page: '/pp' },
        { title: 'Finalize', icon: 'question_answer', page: '/finalize/123456789/salut@coucou.com' },
        { title: 'Verify', icon: 'question_answer', page: '/verify/123456789/salut@coucou.com' },
        { title: 'Reset Password', icon: 'question_answer', page: '/reset-password' },
        { title: 'Reset Password Do', icon: 'question_answer', page: '/reset-password/fghjkl' },
      ]
    }),
    computed: {
      ...mapGetters([
        'env'
      ])
    },
    mounted () {

    }
  }
</script>

<style>

</style>
